export default __webpack_public_path__ + "static/media/concierge-icon.7caf5119.svg";